/** File-derived defaults apply only when each selected PDF contains one page. */
export function singlePagePdfImportDefaults(files: readonly { name: string }[], pageCounts: readonly number[]) {
  if (files.length < 2 || pageCounts.length !== files.length || !pageCounts.every(count => count === 1)) return;
  const names = files.map(file => file.name.trim().replace(/\.pdf$/i, "").trim());
  let prefix = names[0];
  for (const name of names.slice(1)) {
    let length = 0;
    while (length < prefix.length && prefix[length] === name[length]) length++;
    prefix = prefix.slice(0, length);
  }
  return {
    projectName: prefix.trim() || undefined,
    pages: names.map(name => ({ selected: true, floorName: name.slice(prefix.length).trim() || name })),
  };
}
